import { get3PLogo } from '../../icons';
import { type ThirdPartyConfig } from '../../schemas/3p-config';
import { getGithubTypeFilterConfig } from '../type-filter-configs-pure.ts';

import { GithubIcon } from './icon';
import { GithubSearchResultIcon } from './search-result-icon';

export const githubConfig: ThirdPartyConfig = {
	displayName: 'GitHub',
	id: 'github',
	resourceType: 'github-connector',
	icon: get3PLogo(GithubIcon, 'Github', 'medium'),
	searchResultIcon: get3PLogo(GithubSearchResultIcon, 'Github', 'large'),
	integrationAri: 'ari:cloud:platform::integration/github',
	get typeFilterConfig() {
		return getGithubTypeFilterConfig();
	},
	filters: ['lastUpdated', 'onlyTitleMatch', 'pullRequestStatus'],
	requiresOauth: true,
	isEnabled: () => true,
};
